import './toolkit-inverse.scss';
import './dashboard.sass';
import './login.sass';
import './input-select.scss';
